'use strict'

/**
 * Типы actions, доступные для вызова в хранилище
 */

export const TIMER = {
  timeout: {
    update: 'timer/timeout/update'
  },
  lastActionTime: {
    update: 'timer/lastActionTime/update'
  },
  currentTime: {
    update: 'timer/currentTime/update'
  }
}

export const NETWORK = {
  socket: {
    update: {
      connected: 'network/socket/update/connected'
    }
  }
}

export const GUI = {
  loading: {
    set: 'gui/loading/set'
  },
  header: {
    set: 'gui/header/set'
  },
  tryInit: {
    set: 'gui/tryInit/set'
  },
  settings: {
    set: 'gui/settings/set',
    tryInit: {
      set: 'gui/settings/tryInit/set'
    }
  }
}

export const SESSION = {
  reset: 'session/reset',
  set: 'session/set'
}

export const INFO = {
  version: {
    set: 'info/version/set'
  }
}

export const BOARD = {
  tickets: {
    set: 'board/tickets/set'
  },
  clients: {
    queue: {
      set: 'board/clients/queue/set'
    }
  },
  size: {
    set: 'board/size/set'
  },
  states: {
    set: 'board/states/set'
  }
}
export const PLAYLIST = {
  items: {
    set: 'playlist/items/set',
    delete: 'playlist/items/delete'
  },
  adItems: {
    set: 'playlist/adItems/set'
  },
  speakId: {
    set: 'playlist/speakId/set',
    reset: 'playlist/speakId/reset'
  },
  volumeSetting: {
    set: 'playlist/volumeSetting/set'
  },
  mediaMute: {
    set: 'playlist/mediaMute/set',
    reset: 'playlist/mediaMute/reset'
  }
}
